module.exports = {
    VALIDATION_MESSAGE : {
        APP_URL_VALIDATION_FAIL: "Something went wrong with Domain name and Release URL validation",
        DOMAIN_RELEASE_MISMATCH: "Domain URL and Release URL doesn't match",
    },
    VALIDATION_REGEX: {
        APP_URL_VALIDATION: "Application URL validation failed"
    }
}